/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/

// Override Settings
var boostPFSInstantSearchConfig = {
      search: {
          //suggestionMode: 'test',
          //suggestionPosition: 'left'
        // suggestionMobileStyle: 'style1',
        // suggestionStyle: 'style2',
        // suggestionStyle2MainContainerSelector: '.predictive-search .drawer__content',
      },
      general: {
        breakpointMobile: '999'
      }
  };
/*
if(window.innerWidth <= 1199 && window.innerWidth > 999){
  var boostPFSInstantSearchConfig = {
      search: {
          //suggestionMode: 'test',
          //suggestionPosition: 'left'
        suggestionMobileStyle: 'style1',
        suggestionStyle: 'style2',
        suggestionStyle2MainContainerSelector: '.predictive-search .drawer__content',
      },
      general: {
      }
  };
}else{
  if(window.innerWidth <= 767){
    var boostPFSInstantSearchConfig = {
        search: {
           // suggestionMobileStyle: 'style2',
           // suggestionStyle2MainContainerSelector: '.predictive-search .drawer__content',
            //suggestionMode: 'test',
            //suggestionPosition: 'left'
        }
    };
  }else{
    var boostPFSInstantSearchConfig = {
        search: {
            //suggestionMode: 'test',
            //suggestionPosition: 'left'
        }
    };
  }
}
*/

(function() {
    /* start-boost-custom */
    /* #boost-125318: fix search on Safari */
  	document.getElementById('search-drawer').remove();    
    /* end-boost-custom */  
  
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';    
    
    jQ('a[aria-controls="search-drawer"]').each((i, element) => {
      var $this = jQ(element);
      var clone = $this.clone();
      clone.removeAttr('aria-controls').removeAttr('is');
      clone.addClass('search-button');
      clone.attr('href', 'javascript:void()');
      clone.on('click', () => {
        self.openSuggestionMobile();
      });
      
      
      $this.replaceWith(clone);
    });
    
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });
  
  	/*InstantSearchResult.prototype.render = function() {
		//console.log(234);
      if (this.isFirstLoad) {
			// Render initial suggestion container and append it to the dom
			var suggestionHtml = this.compileTemplate();
			this.appendToSelector = '.predictive-search .drawer__content';
			this._applyFilterAutocompleteAppendElement();

			jQ(this.appendToSelector).append(suggestionHtml);
			this.$wrapper = jQ(this.selector.wrapper);
			this.$popoverElement = jQ(this.selector.popover);
			this.isFirstLoad = false;
		} else {
			// Show the suggestion popover
			this.$instantSearchResult.siblings().show();
			// Render suggestion blocks and items
			if (this.isLoading) {
				this._renderSuggestionLoading();
				this._renderWrapper();
			} else {
				this._renderWrapper();
				this._renderSuggestion();
			}

		}
	} */
    
  /* start-boost-custom */
  /* #boost-126047: fix mobile search */
  /* InstantSearchMobile.prototype.beforeRender = function() {
    var buttonClass = 'a[href="/search"]' // Search icon

    var self = this;
    var $button = jQ(buttonClass);

    var clone = $button.clone();  

    clone.on('click',function(e) {
      e.stopPropagation();
      e.preventDefault();
      self.openSuggestionMobile()
    });

    $button.replaceWith(clone); 
  } */
  /* end-boost-custom */

})();